import React from 'react'
import { Col, Row } from 'react-bootstrap'
import "./index.scss"

export const SectionNumber = () => {
  return (
    <div className='SectionNumber-container '>
        <Row className="align-items-center justify-content-center " >
        
          <Col md={3}>
          <div className='Number-container d-flex  align-items-center justify-content-center  flex-column'>
          <h3 className='number'>2000 <span>+</span></h3>
          <h3 className='text'>Projets</h3></div></Col>
                    <Col md={3}><div className='Number-container d-flex  align-items-center justify-content-center  flex-column'>
          <h3 className='number'>10 <span>+</span></h3>
          <h3 className='text'>Consultants</h3></div></Col>
                              <Col md={3}><div className='Number-container d-flex  align-items-center justify-content-center  flex-column'>
          <h3 className='number'>48H <span></span></h3>
          <h3 className='text'>Délai moyen</h3></div></Col>
                                        <Col md={3}><div className='Number-container d-flex  align-items-center justify-content-center  flex-column'>
          <h3 className='number'>85 <span>%</span></h3>
          <h3 className='text'>Clients fidèles</h3></div></Col>
        </Row>
    </div>
  )
}
